// ModelUI/ResetPasswordModal/ResetPasswordModal.js
import React, { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react"; 
import "./ResetPasswordModal.css";

const ResetPasswordModal = ({ onClose, onReset, defaultName = "" }) => {
  const [name, setName] = useState(defaultName);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setName(defaultName || "");
  }, [defaultName]);

  // Password validation rules
  const validatePassword = (password) => {
    if (!password || !password.trim()) {
      return "Password is required";
    }
    if (password.length < 6) {
      return "Password must be at least 6 characters";
    }
    return "";
  };

  const handleReset = () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }

    const validationError = validatePassword(newPassword);
    if (validationError) {
      setError(validationError);
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setError("");
    onReset({ name: name.trim(), password: newPassword.trim() });
    setName("");
    setNewPassword("");
    setConfirmPassword("");
  };

  return (
    <div className="reset-password-modal-overlay">
      <div className="reset-password-modal">
        <h6>Update Agent</h6>

        <div style={{ marginBottom: "10px" }}>
          <input
            type="text"
            style={{ height: 40 }}
            className="form-control"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter name"
          />
        </div>

        <div className="reset-password-input-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            style={{ height: 40 }}
            className="form-control"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter new password"
          />
          <span
            className="reset-password-toggle-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </span>
        </div>

        <div className="reset-password-input-wrapper" style={{ marginTop: "10px" }}>
          <input
            type={showConfirmPassword ? "text" : "password"}
            style={{ height: 40 }}
            className="form-control"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              if (error) setError("");
            }}
            placeholder="Confirm password"
          />
          <span
            className="reset-password-toggle-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </span>
        </div>

        {/* Show validation error */}
        {error && <p className="reset-password-error-text">{error}</p>}

        <div className="reset-password-buttons">
          <button className="popup-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="popup-add-btn" onClick={handleReset}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
